import { post } from './http';

export const add = async ({ articleNumber, quantity = 1 }) => {
    if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
        throw 'Invalid quantity';
    }

    const response = await post('/api/cart/add', {
        articleNumber,
        quantity: parseFloat(quantity),
    });
    return response.json();
};

export const addMany = async (items) => {
    const response = await post('/api/cart/addMany', items);
    return response.json();
};

export const reorder = async (orderId, clearCart) => {
    const response = await post('/api/cart/reorder', { orderId, clearCart });
    return response.json();
};

export const editorder = async (orderId, clearCart) => {
    const response = await post('/api/cart/editorder', { orderId, clearCart });
    return response.json();
}